import React from "react";
import { colors } from "../../colors";
import { MenuItemsIconsMap } from "../navbar/dto";
import { BreadcrumbProps } from "./Breadcrumb.types";

const Breadcrumb: React.FC<BreadcrumbProps> = ({ ...props }) => {
    return (
        <div className="flex flex-row items-center gap-2">
            <span>
                {MenuItemsIconsMap(props.menuItem, props.path.length === 1 ? colors.brandPrimary[200] : colors.brandPrimary[500], 16)}
            </span>
            {props.path.map((item, index) => {
                const isLast = index + 1 === props.path.length;
                return (
                    <div key={index} className="flex flex-row items-center gap-2">
                        <span
                            className="text-sm font-medium tracking-wide"
                            style={{
                                color: isLast ? colors.brandPrimary[200] : colors.brandPrimary[500],
                                letterSpacing: '0.01em'
                            }}
                        >
                            {item}
                        </span>
                        {!isLast && (
                            <span style={{ color: colors.brandPrimary[500], fontSize: '12px', fontWeight: 300 }}>
                                /
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default Breadcrumb;